import { defineMessages } from 'react-intl';

export default defineMessages({
    cancelChangeTitle:{
        "id":"certificatesofinsurance.edit.Discard Changes",
        "defaultMessage":"Discard Changes"
    },
    cancelChangeMessage:{
        "id":"certificatesofinsurance.edit.Are you sure you want to discard your changes?",
        "defaultMessage":"Are you sure you want to discard your changes?"
    },
    
});
